import { render } from "./OrderSummaryAside.vue?vue&type=template&id=0ce08e9f&scoped=true"
import script from "./OrderSummaryAside.vue?vue&type=script&lang=js"
export * from "./OrderSummaryAside.vue?vue&type=script&lang=js"

import "./OrderSummaryAside.vue?vue&type=style&index=0&id=0ce08e9f&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce08e9f"]])

export default __exports__